import React, { useCallback, useState } from "react";

import { CloseIcon as Close } from "@packages/ds";

import * as S from "./SearchInput.styles";

type Props = {
  onChange: (search: string) => void;
};

const SearchInput = ({ onChange }: Props) => {
  const [value, setValue] = useState("");

  const handleChange = useCallback(
    (value: string) => {
      setValue(value);
      onChange(value);
    },
    [onChange]
  );

  const hasValue = !!value;

  return (
    <S.SearchInputRoot>
      <S.SearchInput
        width="100%"
        placeholder="Filter..."
        value={value}
        onChange={event => {
          handleChange(event.target.value);
        }}
      />

      {hasValue && (
        <Close
          fill="var(--granite)"
          onClick={() => {
            handleChange("");
          }}
        />
      )}
    </S.SearchInputRoot>
  );
};

export default SearchInput;
